const RAW_SUPABASE_URL =
  (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim() ||
  (import.meta.env.VITE_PUBLIC_SUPABASE_URL as string | undefined)?.trim() ||
  '';

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

export function getSupabaseBaseUrl(): string {
  if (!RAW_SUPABASE_URL) {
    throw new Error('Missing VITE_SUPABASE_URL');
  }
  return trimTrailingSlash(RAW_SUPABASE_URL);
}

export function getEdgeFunctionUrl(functionName: string): string {
  const normalizedName = functionName.replace(/^\/+/, '');
  return `${getSupabaseBaseUrl()}/functions/v1/${normalizedName}`;
}

export const EDGE_FUNCTION_ENDPOINTS = {
  createOrder: () => getEdgeFunctionUrl('create-order'),
  attendanceCheck: () => getEdgeFunctionUrl('attendance-check'),
  adminStorefrontSortSettingsRead: () => getEdgeFunctionUrl('admin-storefront-sort-settings-read'),
  adminStorefrontSortSettingsUpdate: () => getEdgeFunctionUrl('admin-storefront-sort-settings-update'),
  adminMuviSettingsRead: () => getEdgeFunctionUrl('admin-muvi-settings-read'),
  adminMuviSettingsUpdate: () => getEdgeFunctionUrl('admin-muvi-settings-update'),
  muviBookingSubmit: () => getEdgeFunctionUrl('muvi-booking-submit'),
  adminMuviBookingsList: () => getEdgeFunctionUrl('admin-muvi-bookings-list'),
  adminMuviBookingUpdate: () => getEdgeFunctionUrl('admin-muvi-booking-update'),
  adminMuviBookingsReport: () => getEdgeFunctionUrl('admin-muvi-bookings-report'),
  publicStorefrontSortSettingsRead: () => getEdgeFunctionUrl('public-storefront-sort-settings-read'),
  // Phase4a: Payable summary (read-only, sole source of truth for payable calculation)
  adminGetOrderPayableSummary: () => getEdgeFunctionUrl('admin-get-order-payable-summary'),
};
